import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';

export default function ManagerList(props) {
  const { open, handleClose, companyId, topManagerId, getUser } = props;
  const [managerId, setManagerId] = useState();
  const [managerList, setManagerList] = useState([]);

  const handleChangeSelect = (e) => {
    setManagerId(e.target.value);
  };

  const changeTopManager = async () => {
    await axios
      .post(`/api/company/manager/${managerId}`)
      .then((response) => {
        alert(response.data.message);
        getUser();
        handleClose();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getManagerList = async () => {
    await axios
      .get(`/api/company/manager/${companyId}`)
      .then((response) => {
        if (!!response.data) {
          setManagerList(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  useEffect(async () => {
    setManagerId(topManagerId);
    if (companyId) {
      await getManagerList();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">수석 매니저 변경</DialogTitle>
      <DialogContent dividers>
        <Divider />
        <FormControl sx={{ minWidth: 300 }}>
          <InputLabel id="label">수석 매니저 선택</InputLabel>
          <Select labelId="label" id="topManager" name="topManager" value={managerId} label="수석 매니저" onChange={handleChangeSelect}>
            {managerList.map((item, idx) => {
              return (
                <MenuItem key={`${idx}`} value={item.id}>
                  <ListItemText primary={`${item.userid}(${item.username})`} />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={changeTopManager}>
          변경
        </Button>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
